module.exports = __webpack_public_path__ + "static/media/monument-branding.d35209f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/monument-branding.png
// module id = 217
// module chunks = 0